export const actionTypes = {
    SET_ACTIVE_TAB: 'operationalParametersV2/SET_ACTIVE_TAB',
    SET_DATE_SELECTION: 'overview_v2/SET_DATE_SELECTION',
    SET_SELECTED_ASSET: 'powertrainAssetDetails/SET_SELECTED_ASSET',
    LOAD_MEASUREMENT: 'operationalParameters_v2/LOAD_MEASUREMENT',
    LOAD_MEASUREMENT_LEGACY: 'operationalParameters_v2/LOAD_MEASUREMENT_OLD',
    COLLECT_RAW_DATA: 'operationalParameters_v2/COLLECT_RAW_DATA',
    COLLECT_RAW_DATA_LEGACY: 'operationalParameters_v2/COLLECT_RAW_DATA_LEGACY',
    SET_ACTIVE_TREND_TAB: 'operationalParameters/SET_ACTIVE_TREND_TAB',
    SET_MULTICHART_CONFIG: 'operationalParameters_v2/SET_MULTICHART_CONFIG',
    GET_MULTI_TREND_DATA: 'operationalParameters_v2/GET_MULTI_TREND_DATA',
    CLEAR_MULTICHART_DATA: 'operationalParameters_v2/CLEAR_MULTICHART_DATA',
    CLEAR_UNMONITORED_CHART_DATA: 'operationalParameters_v2/CLEAR_UNMONITORED_CHART_DATA',
    CLEAR_OPERATIONAL_PARAMETERS_API_ERRORS: 'operationalParameters_v2/CLEAR_OPERATIONAL_PARAMETERS_API_ERRORS',
    CLEAR_COLLECT_RAW_DATA_ERROR: 'operationalParameters_v2/CLEAR_COLLECT_RAW_DATA_ERROR',
};

export const opButtons = {
    trends: 'Trends',
    scatterPlot: 'ScatterPlot',
    scatterPlotV2: 'ScatterPlot V2',
    histogram: 'Histogram',
    histogramV2: 'Histogram V2',
    vibrationFFT: 'VibrationFFT',
    vibrationFFTV2: 'VibrationFFT V2'
};

export const multiChartOptions = {
    SINGLE: 'single',
    MULTI: 'multi'
};

export const multiChartToggleOptions = [{
    label: 'ABB.Powertrain.Frontend.operationalParametersSingleGraph',
    value: multiChartOptions.SINGLE
},
{
    label: 'ABB.Powertrain.Frontend.operationalParametersMultiGraph',
    value: multiChartOptions.MULTI
}];

export const tabContainerIds = {
    [opButtons.trends]: 'trend-container',
    [opButtons.scatterPlot]: 'scatter-container',
    [opButtons.scatterPlotV2]: 'scatter-container',
    [opButtons.histogram]: 'histogram-container',
    [opButtons.histogramV2]: 'histogram-container',
    [opButtons.vibrationFFT]: 'vibration-fft-container',
    [opButtons.vibrationFFTV2]: 'vibration-fft-container'
};
